<template>
  <div>
    <!-- Stats Card Horizontal -->
    <b-row>
      <b-col lg="12">

        <b-row>
          <b-col cols="12">
            <b-card style="width: 100%; height: 390px;">
              <b-card-header>
                <b-card-title
                  style="font-size: 22px; border: 5px; text-decoration: underline; margin-top: -30px;"
                >
                  สถิติการตรวจสอบเหตุการณ์ที่อาจจะเกิดอุบัติเหตุภายใน 7 วัน
                </b-card-title>
              </b-card-header>
              <app-echart-line
                style="height: 300px;"
                :option-data="option"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, VBModal,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { Icon } from 'leaflet'
import AppEchartLine from '@/views/analytic120/detailCarstop/garaphLineAG/AppEchartLineAG.vue'
import 'leaflet/dist/leaflet.css'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {

    // BCard,
    BRow,
    BCol,
    // BEmbed,
    BCard,
    AppEchartLine,
    // flatPickr,
    BCardHeader,
    // BDropdown,
    // BDropdownItem,
    // BDropdownDivider,
    BCardTitle,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      revenueGenerated: {},
      name: [],
      items: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      option: {
        xAxisData: [],
        series: [
          {
            name: 'รถย้อนศร',
            type: 'line',
            areaStyle: {
              color: 'rgb(255,0,255,0.1)',
            },
            color: '#DC48FF',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 2,
              color: '#DC48FF',
            },
            data: [],
          },
          {
            name: 'รถหยุด',
            type: 'line',
            areaStyle: {
              color: 'rgb(0,0,255,0.1)',
            },
            color: '#579BFE',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 2,
              color: '#579BFE',
            },
            data: [],
          },
        ],
      },
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.graphAnalytic()
    setInterval(() => {
    }, 300000)
  },
  methods: {
    graphAnalytic() {
      if (this.$route.query.type !== '0') {
        axios
          .post('getGraphAnalytic-CS-G', { wid: this.$route.query.wid })
          .then(response => {
            this.xAxisData = []
            this.xAxisData[0] = response.data
            this.xAxisData[0][0].forEach(value => {
              if (response.data[0].length >= 5) {
                this.option.xAxisData.push(value.Date_Name)
              }
              this.option.series[0].data.push(value.Wrong_Way)
            })
            this.xAxisData[0][1].forEach(value => {
              this.option.series[1].data.push(value.Car_Stop)
            })
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('getGraphAnalytic-CS', { wid: this.$route.query.wid })
          .then(response => {
            this.xAxisData = []
            this.xAxisData[0] = response.data
            this.xAxisData[0][0].forEach(value => {
              if (response.data[0].length >= 5) {
                this.option.xAxisData.push(value.Date_Name)
              }
              this.option.series[0].data.push(value.Wrong_Way)
            })
            this.xAxisData[0][1].forEach(value => {
              this.option.series[1].data.push(value.Car_Stop)
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped >
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.pie-text1{
    width: 200px;
    position:absolute;
    margin: auto;
    left: 85%;
    right: 0;
    top: 25%;
    bottom: 0;
  }
.bg-color {
    color: #FF9999;
}

.table-responsive{
   font-size: 15px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}
.vue2leaflet-map{
  &.leaflet-container{
    height: 200px;
  }
}
.leaflet-popup-content {
  margin: 10px 10px;
}
.leaflet-container a.leaflet-popup-close-button {
  padding: 0 0 0 0
}
.apexcharts-legend-text {
  color: rgb(210, 176, 255)
}

</style>
